import type { ICountryWorkingDays } from 'src/types/country-working-days';

/** Weekend used when a country has no working-days config (0 = Sunday … 6 = Saturday). */
export const DEFAULT_NON_WORKING_DAYS: number[] = [0, 6];

const MOBISCROLL_WEEKDAYS = ['SU', 'MO', 'TU', 'WE', 'TH', 'FR', 'SA'];

export type NonWorkingDaysResolver = (countryCode: string | null | undefined) => number[];

/**
 * Non-working weekdays per country, from the client's working-days config (Organisation →
 * Configuration → Working days). Countries without a config keep the default Sat/Sun weekend,
 * like the backend allocator.
 */
export function createNonWorkingDaysResolver(
  countryWorkingDays: ICountryWorkingDays[]
): NonWorkingDaysResolver {
  const nonWorkingByCountry = new Map<string, number[]>(
    countryWorkingDays.map(({ countryCode, workingDays }) => [
      countryCode.trim().toUpperCase(),
      [0, 1, 2, 3, 4, 5, 6].filter((day) => !(workingDays as number[]).includes(day)),
    ])
  );
  return (countryCode) =>
    nonWorkingByCountry.get(countryCode?.trim().toUpperCase() ?? '') ?? DEFAULT_NON_WORKING_DAYS;
}

/** Mobiscroll recurring `weekDays` value, e.g. `[5, 6]` → `'FR,SA'`. */
export function toMobiscrollWeekDays(days: number[]): string {
  return [...days]
    .sort((a, b) => a - b)
    .map((day) => MOBISCROLL_WEEKDAYS[day])
    .join(',');
}
